<template>
  <base-status-page>
    <template v-slot:headertext="slotProps">
      <h1 class="display-2 text-white">{{ slotProps.website.name }}</h1>

      <p v-if="slotProps.website.description" class="text-white mt-0 mb-3">
        {{ slotProps.website.description }}
      </p>

      <p v-else class="text-white mt-0 mb-3">
        Check here for updates about {{ slotProps.website.name }}'s service
        availablity and performance.
        <br />
        <span v-if="isWebsitePremium">
          Subscribe to get real-time updates via email, RSS, Slack, and more.
          <br />
        </span>
      </p>

      <subscribe-button v-if="isMobile && isWebsitePremium"></subscribe-button>
    </template>
  </base-status-page>
</template>
<script>
import BaseStatusPage from "@/components/Custom/BaseStatusPage";
import SubscribeButton from "@/components/Custom/SubscribeButton";

import { mapState, mapGetters, mapActions } from "vuex";

export default {
  components: {
    BaseStatusPage,
    SubscribeButton
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("website", ["isWebsitePremium"])
  },
  methods: {},
  async created() {}
};
</script>
<style></style>
